import { Map } from 'immutable'
import {
  SET_LANGUAGES_PROCESSING,
  SET_LANGUAGES_DATA,
  SET_LANGUAGES_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_LANGUAGES_PROCESSING:
      return state.setIn(['processing'], payload.processing)
    case SET_LANGUAGES_DATA:
      return state
        .setIn(['data'], payload.data)
        .setIn(['processing'], false)
    case SET_LANGUAGES_ERROR:
      return state
        .setIn(['error'], payload.error)
        .setIn(['processing'], false)
    default:
      return state
  }
}
